export default "__VITE_ASSET__6c4589cc__"